import {
    Component,
    h,
    Host,
    Element,
    ComponentInterface,
    Prop,
} from "@stencil/core";

export type ProgressBarVariant = "light" | "dark";

@Component({
    tag: "uic-progress-bar",
    styleUrl: "progress-bar.scss",
})
export class ProgressBar implements ComponentInterface {
    @Element() host: HTMLUicProgressBarElement;

    /** The current progress, relative to 100 or `max`, if defined */
    @Prop() value: number = 0;

    /** The maximum value of the progress bar */
    @Prop() max: number = 100;

    /** The variant to use. Use the "light" variant on dark backgrounds */
    @Prop() variant: ProgressBarVariant = "dark";

    render() {
        return (
            <Host
                class={{
                    "uic-progress-bar": true,
                    [`uic-progress-bar--${this.variant}`]: true,
                }}
            >
                <progress value={this.value} max={this.max}></progress>
            </Host>
        );
    }
}
